import { render, staticRenderFns } from "./CardLayout.vue?vue&type=template&id=b59e5b6c&scoped=true&"
import script from "./CardLayout.vue?vue&type=script&lang=js&"
export * from "./CardLayout.vue?vue&type=script&lang=js&"
import style0 from "./CardLayout.vue?vue&type=style&index=0&id=b59e5b6c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b59e5b6c",
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QSeparator});
